// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"15cf05c9","239":"51e93f6e","257":"d8971785","389":"641ab576","453":"9dca6088","732":"f5457ef3","977":"d001c8f9"}[chunkId] + ".chunk.js";
};